<template>
    <h3 class="sub-section-header" v-text="title" />
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss">
.sub-section-header {
    font-size: 1.625rem;
    margin-bottom: 0;
}
</style>